<template>


  <div>

    <div class="trz-leave-settings-wrapper">
      <b-tabs pills card content-class="bg-white py-0" nav-class="bg-white " nav-wrapper-class="trz-wizard-sidebar-settings">
        <b-tab active title="General Settings" v-if="$acl['roster/settings'] == 2">

          <div class="clearfix ">
            <roster-general-settings  ></roster-general-settings>
          </div>


        </b-tab>
        <b-tab lazy title="Leave Category"  v-if="$acl['roster/leave/types'] == 2">
          <div class="clearfix ">
            <roster-leave-types></roster-leave-types>
          </div>
        </b-tab>
        <b-tab lazy title="Leave & Attendance Policy" v-if="$acl['roster/leave/policies'] == 2">
          <div class="clearfix ">
            <roster-leave-policies></roster-leave-policies>
          </div>
        </b-tab>

        <b-tab lazy title="Holidays" v-if="$acl['roster/company/holidays'] == 2">
          <div class="clearfix ">
            <roster-holidays-managed-by-system-user v-if="supper_user == true"></roster-holidays-managed-by-system-user>
            <roster-holidays v-else></roster-holidays>
          </div>
        </b-tab>

        <b-tab lazy title="Attendance Devices" v-if="$acl['roster/device'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-attendance-devices></roster-attendance-devices>
            </div>
          </div>
        </b-tab>

        <b-tab lazy title="Geo Locations" v-if="$acl['geolocation/mapemployee/all'] == 2">
          <div class="clearfix">
            <div class="">
              <all-geolocations></all-geolocations>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Roster Management" v-if="$acl['roster/list'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-rosters></roster-rosters>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Shifts" v-if="$acl['roster/shifts'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-shifts></roster-shifts>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Off Day Template" v-if="$acl['roster/offday/template'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-off-day-template></roster-off-day-template>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Penalty" v-if="$acl['roster/penalty'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-penalty-policy></roster-penalty-policy>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Overtime" v-if="$acl['roster/overtime'] == 2">
          <div class="clearfix">
            <div class="">
              <roster-overtime-policy></roster-overtime-policy>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Attendance Mobility">
          <div class="clearfix">
            <div class="">
              <roster-mobility></roster-mobility>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Approver">
          <div class="clearfix">
            <div class="">
              <roster-approver-settings></roster-approver-settings>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Long Service Leave">
          <div class="clearfix">
            <div class="">
              <roster-long-service-leave-settings></roster-long-service-leave-settings>
            </div>
          </div>
        </b-tab>
        <b-tab lazy title="Feature Access">
          <div class="clearfix">
            <div class="">
              <roster-module-access></roster-module-access>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>





</template>
<script>
export default{
  data(){
    return {
      supper_user: false,
    }
  },

  methods:{
    checkSuperUser : function() {
      axios.get(this.$api_url+'/user-type-level').then(function(response){
        if((response.data.user_type == '1') && (response.data.user_level == '1'))
          this.supper_user = true;
      }.bind(this));
    },
    created(){
      this.checkSuperUser();
    }
  }

}
</script>
